import DialogType from './DialogType';

export default class BotDialogType extends DialogType {
  constructor({ message, scroll = true, checkpoint = false, goBackMessage = false, tooltip }) {
    super({
      typeDialog: 'bot',
      message,
      scroll,
    });
    this.checkpoint = checkpoint;
    this.goBackMessage = goBackMessage;
    this.tooltip = tooltip;
  }
}
